import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import Heading from '@atlaskit/heading';
import * as queryString from 'query-string';

import AccountVerificationForm from '../components/AccountVerificationForm';
import { URLParameters } from '../types';
import WhiteboxPage from '../components/WhiteboxPage';
import { changeEmailConfirmation } from '../actions/change-email-actions';
import {
  useButtonClickedEvent,
  usePageViewedEvent,
} from '../utilities/analytics/analytics-web-client';
import messages from './EmailConfirmationPage.messages';
import { useAppDispatch, useAppSelector } from '../stores/redux.store';

const pageId = 'EmailConfirmationPage';

export const EmailConfirmationFormPage = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const { email, newEmail, error } = useAppSelector(state => state.changeEmail);

  const [fieldErrors, setFieldErrors] = useState(
    error === 'invalid_password' ? { password: intl.formatMessage(messages.incorrectPassword) } : {}
  );
  const [isLoading, setIsLoading] = useState(false);
  const handleLoginClick = useButtonClickedEvent(pageId, 'EmailConfirmationSubmit');

  usePageViewedEvent(pageId);

  // In the URL from the verification email, but used by SIS to validate that they have access to the email address.
  // These three are included in the URL
  const {
    token = '',
    userId = '',
    source = '',
  }: URLParameters = queryString.parse(window.location.search);

  const handleChangePassword = (newEmail: string, password: string) => {
    setIsLoading(true);
    dispatch(changeEmailConfirmation(newEmail, password, token, userId, source));
  };

  const resetPasswordLink =
    '/login/resetpassword?' +
    new URLSearchParams([
      ['redirectedFrom', 'change-email'],
      ['email', email],
      ['continue', window.location.href],
    ]);

  return (
    <WhiteboxPage
      pageId={pageId}
      header={
        <Heading as={'h1'} size={'small'}>
          <FormattedMessage {...messages.title} />
        </Heading>
      }
      whiteboxFooter={
        <Link to={resetPasswordLink} id="resetPassword">
          <FormattedMessage
            id="having.trouble.logging.in"
            defaultMessage="Having trouble logging in?"
          />
        </Link>
      }>
      <AccountVerificationForm
        email={newEmail}
        emailFieldLabel={<FormattedMessage {...messages.emailLabel} />}
        isLoading={isLoading}
        fieldErrors={fieldErrors}
        onValidationError={setFieldErrors}
        submitButtonText={<FormattedMessage id="common.confirm" defaultMessage="Confirm" />}
        onSubmitClick={handleLoginClick}
        onSubmit={handleChangePassword}
      />
    </WhiteboxPage>
  );
};

export default EmailConfirmationFormPage;
